<sw-card-view>
    <sw-card
        class="frosh-tools-tab-files__files-card"
        :class="isLoadingClass"
        :title="$t('frosh-tools.tabs.files.title')"
        :isLoading="isLoading"
        :large="true"
        positionIdentifier="frosh-tools-tab-files__files-card"
        deprecated
    >
        <sw-alert
            variant="error"
            deprecated
            v-if="items.error"
        >{{ items.error }}</sw-alert>
        <sw-alert
            variant="success"
            deprecated
            v-if="items.ok"
        >
            {{ $t('frosh-tools.tabs.files.allFilesOk') }}
        </sw-alert>
        <sw-alert
            variant="warning"
            v-else-if="items.files"
            deprecated
        >
            {{ $t('frosh-tools.tabs.files.notOk') }}
        </sw-alert>
        <template #toolbar>
            <!-- @todo: Make the refresh button fancy -->
            <sw-button
                variant="ghost"
                deprecated
                @click="refresh"
            >
                <sw-icon
                    :small="true"
                    deprecated
                    name="regular-undo"
                ></sw-icon>
            </sw-button>
        </template>
        <sw-data-grid
            v-if="items.files && items.files.length"
            :showSelection="false"
            :dataSource="items.files"
            :columns="columns"
        >
            <template #column-name="{ item }">
                <a
                    @click="diff(item)"
                    :title="$t('frosh-tools.tabs.files.restore.diff')"
                >{{ item.name }}</a>
            </template>

            <template #column-expected="{ item }">
                <span v-if="item.expected">
                    {{ $t('frosh-tools.tabs.files.expectedProject') }}
                </span>
                <span v-else>
                    {{ $t('frosh-tools.tabs.files.expectedAll') }}
                </span>
            </template>

            <template #actions="{ item }">
                <sw-context-menu-item @click="openUrl(item.shopwareUrl)">
                    {{ $t('frosh-tools.tabs.files.openOriginal') }}
                </sw-context-menu-item>
                <sw-context-menu-item @click="diff(item)">
                    {{ $t('frosh-tools.tabs.files.restore.diff') }}
                </sw-context-menu-item>
            </template>
        </sw-data-grid>
    </sw-card>
    <sw-modal
        v-if="showModal"
        variant="large"
        @modal-close="closeModal"
        :title="diffData.file.name"
    >
        <span
            style="white-space: pre"
            v-html="diffData.html"
        ></span>
        <template #modal-footer>
            <sw-button
                variant="ghost-danger"
                deprecated
                @click="restoreFile(diffData.file.name)"
                :disabled="diffData.file.expected"
            >
                <sw-icon
                    name="regular-exclamation-triangle"
                    deprecated
                ></sw-icon>
                {{ $t('frosh-tools.tabs.files.restore.restoreFile') }}
            </sw-button>
        </template>
    </sw-modal>
    <sw-card
        class="frosh-tools-tab-files__extension-files-card"
        :class="isLoadingClass"
        :title="$t('frosh-tools.tabs.extensionFiles.title')"
        :isLoading="isLoading"
        :large="true"
        :deprecated="true"
        positionIdentifier="frosh-tools-tab-files__extension-files-card"
    >
        <sw-alert
            variant="success"
            v-if="extensionItems.success"
        >
            {{ $t('frosh-tools.tabs.extensionFiles.allFilesOk') }}
        </sw-alert>
        <sw-alert
            variant="warning"
            v-else
        >
            {{ $t('frosh-tools.tabs.extensionFiles.notOk') }}
        </sw-alert>
        <template #toolbar>
            <!-- @todo: Make the refresh button fancy -->
            <sw-button
                variant="ghost"
                @click="refresh"
            >
                <sw-icon
                    :small="true"
                    name="regular-undo"
                ></sw-icon>
            </sw-button>
        </template>
        <div
            v-for="(extensionResult, extensionName) in extensionItems.extensionResults"
        >
            <h4>{{ extensionName }}</h4>
            <sw-alert
                variant="warning"
                v-if="extensionResult.wrongExtensionVersion"
            >
                {{ $t('frosh-tools.tabs.extensionFiles.wrongExtensionVersion') }}
            </sw-alert>
            <sw-alert
                variant="error"
                v-if="extensionResult.checkFailed"
            >
                {{ $t('frosh-tools.tabs.extensionFiles.checkFailed') }}
            </sw-alert>
            <sw-description-list v-else>
                <dt v-if="extensionResult.newFiles.length > 0">
                    {{ $t('frosh-tools.tabs.extensionFiles.newFiles') }}
                </dt>
                <dd v-for="file in extensionResult.newFiles">
                    {{ file }}
                </dd>
                <dt v-if="extensionResult.changedFiles.length > 0">
                    {{ $t('frosh-tools.tabs.extensionFiles.changedFiles') }}
                </dt>
                <dd v-for="file in extensionResult.changedFiles">
                    {{ file }}
                </dd>
                <dt v-if="extensionResult.missingFiles.length > 0">
                    {{ $t('frosh-tools.tabs.extensionFiles.missingFiles') }}
                </dt>
                <dd v-for="file in extensionResult.missingFiles">
                    {{ file }}
                </dd>
            </sw-description-list>
        </div>
    </sw-card>
</sw-card-view>